import { create } from 'zustand'

import type { LandingHeader } from '@entities/LandingPage'

/*
  Which chrome the layout renders:
    default  -> the full site header
    minimal  -> checkout header
    landing  -> a landing's own header, configured via `landingHeader`
    hidden   -> no header at all
*/
type HeaderVariant = 'default' | 'minimal' | 'landing' | 'hidden';

interface HeaderStore {
  variant: HeaderVariant;
  /** Config for the landing variant (logo / search overrides). */
  landingHeader: LandingHeader | null;
  setVariant: (variant: HeaderVariant) => void;
  /*
    Set by the landing page once its config is known, and reset on unmount so
    the next page gets the site header back.
  */
  setLandingHeader: (variant: HeaderVariant, header?: LandingHeader | null) => void;
  resetHeader: () => void;
}

export const useHeaderStore = create<HeaderStore>((set) => ({
  variant: 'default',
  landingHeader: null,
  setVariant: (variant) => set({ variant }),
  setLandingHeader: (variant, header = null) => set({ variant, landingHeader: header }),
  resetHeader: () => set({ variant: 'default', landingHeader: null }),
}))
